/*
*
* @module : Main
* @file : Main.js 
* @author : Abhishek Bhatt
* @summary : This file contains the all function of main
*
* Created on : 09-Oct-2019
* @Last Modified by : Abhishek Bhatt
* @Last Modified time : 09-Dec-2019
*/

import React from 'react';
import {Switch, Route} from 'react-router-dom';
import Home from '../../pages/Home/Home';
import Topics from '../../pages/Topics/Topics';
import Questions from '../../pages/Questions/Questions';
import SendGift from '../../pages/Gifts/SendGift';
import Result from '../../pages/Result/Result';
import UserDetails from '../../pages/Users/UserDetails';
import ThankYou from '../../pages/ThankYou/ThankYou';
import Donate from '../../pages/Donate/Donate';
import PlayAgain from '../../pages/PlayAgain/PlayAgain';
import Challenge from '../../pages/Challenge/Challenge';
import QuizEnd from '../../pages/ThankYou/QuizEnd';
import ProtectedRoute from '../../ProtectedRoute';
import ReactGA from 'react-ga';
ReactGA.initialize('UA-6092242-12');
ReactGA.pageview(window.location.pathname + window.location.search);

function Main()
{
	return (
		<main>
			<Switch>
				<Route exact path='/' component={Home} />
				<Route exact path='/topics' component={Topics} />
				<ProtectedRoute exact path='/topics/:topic_id/question' component={Questions} />
				<ProtectedRoute path='/result' component={Result} />
				<ProtectedRoute path='/send-gift' component={SendGift} />
				<ProtectedRoute path='/user-details' component={UserDetails} />
				<ProtectedRoute path='/thank-you' component={ThankYou} />
				<ProtectedRoute path="/play-again" component={PlayAgain}/>
				<ProtectedRoute path='/donate' component={Donate} />
				<Route exact path='/challenge/:challenge_id' component={Challenge} />
				<Route exact path='/quiz-end' component={QuizEnd} />
			</Switch>
		</main>
	);
	window.onbeforeunload = function() {
		sessionStorage.clear();
	}
}

export default Main;
